import {ListItemAvatar, styled} from "@mui/material";

export const TopAlignedListItemAvatar = styled(ListItemAvatar)(({theme}) => ({
  alignSelf: "start", paddingTop: theme.spacing(1)
}));